import {Moment} from 'moment';
import moment from 'moment-timezone';

export const getMomentTime =
    (timestamp: number, timezone_name: string): Moment => moment.unix(timestamp).tz(timezone_name);
